var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportiveCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.041 512.041",
    height: 512,
    viewBox: "0 0 512.041 512.041",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405.125 121.85c0 12.253-4.838 23.718-13.619 32.282l-64.819 62.846-64.81-62.836c-8.791-8.573-13.629-20.038-13.629-32.291 0-24.864 20.229-45.093 45.096-45.093 12.734 0 24.846 5.429 33.342 14.75 8.496-9.321 20.608-14.75 33.342-14.75 24.869-.001 45.097 20.227 45.097 45.092z",
    fill: "#ff3f5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.125 121.85c0 12.253-4.838 23.718-13.619 32.282l-64.819 62.846v-125.471c8.496-9.321 20.608-14.75 33.342-14.75 24.868 0 45.096 20.228 45.096 45.093z",
    fill: "#dd0056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.72 291.874-34 32.79-109.99 106.08h-187.16l-89.07-32.52v-136.13c20.06-23.09 49.03-36.32 79.59-36.32 28.34 0 55.32 11.38 75.09 31.45h81.76c2.06.01 4.1.37 6.02 1.1 12.95 4.92 22.17 17.47 22.13 32.13-.05 18.8-16.15 34.18-34.96 34.18h-95.68v30.32h96.36c23.02 0 43.26-12.11 54.69-30.29 5.04-8 8.37-17.19 9.48-27.04l70.88-64.37c8-7.26 18.35-10.95 29.14-10.37s20.69 5.35 27.87 13.43c14.35 16.16 13.41 40.56-2.15 55.56z",
    fill: "#f2cecd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.72 324.664-109.99 106.08h-187.16l-89.07-32.52v-73.56h133.95v30.29h96.36c23.02 0 43.26-12.11 54.69-30.29z",
    fill: "#e8b4b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.33 257.054v135.23c0 23.71-19.29 43-43 43h-39.33v-221.23h39.33c23.71 0 43 19.29 43 43z",
    fill: "#84caff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.33 324.664v67.62c0 23.71-19.29 43-43 43h-39.33v-110.62z",
    fill: "#9aa3e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportiveCare);
export default __webpack_public_path__ + "static/media/Supportive_Care.76e01806f60ff17db9555f994a6580b0.svg";
export { ForwardRef as ReactComponent };